import { isMobile } from '../services/mql-service';
import {
  getTotalGlobalTopContentHeight,
  getTrueHeight,
  scrollToElement,
} from '../services/window-service';

class LocationAnchorMenu extends DrupalBehavior {
  context;

  onReady(context) {
    this.context = context;
    this.setUpAnchorMenuLinks();

    gsap.registerPlugin(ScrollToPlugin);
    this.setUpAnchorMenuClickEvents();
    this.setStickyScrollValues();
    this.initScrollSpy();
  }

  initScrollSpy() {
    const headings = $(this.context).find('h2[data-anchor]');
    const menuLinks = $(this.context).find(
      '.location-anchor--items a[data-anchor-id]'
    );

    $(window).on('scroll', () => {
      let currentActiveId = null;

      const thirds = 3;
      const fourths = 4;
      const lastFourth = thirds * (window.innerHeight / fourths);
      const triggerPoint = window.innerHeight - lastFourth;

      headings.each(function (index) {
        const bounding = this.getBoundingClientRect();

        const nextHeading = headings[index + 1];
        const nextBounding = nextHeading
          ? nextHeading.getBoundingClientRect()
          : null;

        if (
          bounding.top <= triggerPoint &&
          (!nextBounding || nextBounding.top > triggerPoint)
        ) {
          currentActiveId = $(this).attr('data-anchor');
        }
      });

      if (currentActiveId !== null) {
        menuLinks.removeClass('active');
        menuLinks
          .filter(`[data-anchor-id="${currentActiveId}"]`)
          .addClass('active');
      } else {
        menuLinks.removeClass('active');
      }
    });
  }

  setStickyScrollValues() {
    const menus = this.context.querySelectorAll('.location-anchor-menu');
    menus.forEach((menu) => {
      menu.style.top = `${getTotalGlobalTopContentHeight()}px`;
    });
  }

  setUpAnchorMenuClickEvents() {
    const _this = this;

    $(once('anchor-item-link', '.location-anchor--items a', this.context)).on(
      'click',
      function (e) {
        e.preventDefault();
        _this.scrollToSection(this);

        if (isMobile()) {
          _this.closeMobileModal(this);
        }
      }
    );
  }

  closeMobileModal(link) {
    $(link).closest('.rush-modal')[0].close();
  }

  scrollToSection(link) {
    const anchorId = $(link).attr('data-anchor-id');
    scrollToElement(this.context, '[data-anchor="' + anchorId + '"]');
  }

  setUpAnchorMenuLinks() {
    const $anchorMenuList = $(
      once(
        'location-anchor-menu-list',
        '.location-anchor--items ul',
        this.context
      )
    );

    const oppositeH2Tag = isMobile() ? '.desktop-only' : '.mobile-only';

    $('.locations-wrap .content h2')
      .not('.visually-hidden, .no-section')
      .not(`${oppositeH2Tag} h2`)
      .not(oppositeH2Tag)
      .each((index, heading) => {
        this.setAnchorIdOnHeading($(heading), index);
        $anchorMenuList.append(
          `<li>
            <a
              href="#"
              data-anchor-id="${index}">
                ${$(heading).text()}
            </a>
          </li>`
        );
      });
  }

  setAnchorIdOnHeading($heading, index) {
    if (isMobile()) {
      !$heading.hasClass('desktop-only') && $heading.attr('data-anchor', index);
    } else {
      !$heading.hasClass('mobile-only') && $heading.attr('data-anchor', index);
    }
  }
}

DrupalBehavior.register(
  'rush_theme.components',
  'location_anchor_menu',
  LocationAnchorMenu
);
